export class BroadcastChannelManager<T> {
  channel: BroadcastChannel

  constructor(channelName: string) {
    this.channel = new BroadcastChannel(channelName)
  }

  on(callback: (event: MessageEvent<T>) => void) {
    this.channel.addEventListener('message', callback)
  }

  off(callback: (event: MessageEvent<T>) => void) {
    this.channel.removeEventListener('message', callback)
  }

  emit(data: T) {
    this.channel.postMessage(data)
  }

  close() {
    this.channel.close()
  }
}
